import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingStatusService {
  public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public error$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public isInErrorState$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  /**
   * Sets error text encountered when loading data or form.
   * @param errorText The error
   */
  setLoadingError(errorText: string) {
    this.error$.next(errorText);
    this.isInErrorState$.next(!!errorText.trim());
  }

  /**
   * Gets the current error text.
   * @returns the error
   */
  getLoadingError() {
    return this.error$.value;
  }

  /**
   * Sets the loading status. Note, you should only use this when you want to block the
   * user from UI interaction while something is retrieved / computed.
   * @param isLoading true if we're currently loading
   */
  setLoadingStatus(isLoading = false) {
    this.isLoading$.next(isLoading);
  }

  /**
   * Gets the current status. If you want to be notified of when this status changes,
   * subscribe to the isLoading$ observable in this service.
   * @returns true if we're currently loading.
   */
  getLoadingStatus(): boolean {
    return this.isLoading$.value;
  }
}
